var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('div',{staticClass:"app-body"},[_c('AppHeader'),_c('div',{staticClass:"main flexbox flex-top wrap"},[_c('AppMenu'),_c('router-view')],1),_c('slideout-panel')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }